import type { TLoggerMessages } from '~shared/services/logger';
import { DatadogLogger, LoggerServices } from '~shared/services/logger';
import { getEnv } from '~shared/utils/env';

export const sendMetricToAPI = async (
	metricData: {
		name: string;
		tags: string[];
		value?: number;
		type?: 'gauge' | 'counter';
		raw?: Record<string, unknown>;
	},
	errorMessage: TLoggerMessages
) => {
	try {
		await fetch('/api/metrics', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				...metricData,
				env: getEnv(),
				source: 'webapp',
			}),
		});
	} catch (error) {
		DatadogLogger.error(
			LoggerServices.MetricsService,
			errorMessage,
			error as Record<string, unknown>
		);
	}
};
